module.exports = __webpack_public_path__ + "assets/d63f23d6ab43f339160c86fe1e50964e.png";